import Link from 'next/link';

interface LoginFooterProps {
  className?: string;
}

export const LoginFooter: React.FC<LoginFooterProps> = ({ className }) => {
  return (
    <>
      <span className="mt-6 font-light text-sm lg:absolute lg:left-2 lg:bottom-6">
        © 2025 FIT Wind, LLC.
      </span>
      <div className="mt-2 space-x-6 font-light text-sm lg:absolute lg:left-1/2 lg:-translate-x-1/2 lg:bottom-6">
        <Link href={'/legal/privacy-policy'} className="text-alter-black-80">
          Privacy Policy
        </Link>
        <Link href={'/legal/terms-of-use'} className="text-alter-black-80">
          Terms of Use
        </Link>
      </div>
    </>
  );
};
